import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import config from '../data/site_config.json';

const GoogleAnalytics = () => {
    const location = useLocation();

    useEffect(() => {
        // Initialize GA4 if ID is present
        if (config.googleAnalyticsId && config.googleAnalyticsId !== 'G-XXXXXXXXXX') {
            ReactGA.initialize(config.googleAnalyticsId);
        }
    }, []);

    useEffect(() => {
        // Send pageview on route change
        if (config.googleAnalyticsId && config.googleAnalyticsId !== 'G-XXXXXXXXXX') {
            ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
        }
    }, [location]);

    return null;
};

export default GoogleAnalytics;
